import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/person.jpg'


const _hoisted_1 = { key: "about" }
const _hoisted_2 = { class: "container my-5" }
const _hoisted_3 = { class: "flex flex-col items-center" }
const _hoisted_4 = { class: "row align-items-center mt-5" }
const _hoisted_5 = { class: "col-12 col-md-4 text-center mb-4 mb-md-0 d-flex flex-wrap gap-3 table-hover" }
const _hoisted_6 = { class: "w-25 w-md-35 rounded flex-grow-5 flex-shrink-1" }
const _hoisted_7 = ["href", "target", "title"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "list-unstyled" }
const _hoisted_10 = ["href", "target"]

import Footer from "@/components/Footer.vue";
import ReadMoreText from "@/components/ReadMoreText.vue";
import { useAboutViewStore } from "@/stores/AboutViewStore";
import { useGlobalStore } from "@/stores/GlobalStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const globalStore = useGlobalStore();
const aboutViewStore = useAboutViewStore();

const removeNameFromDescriptionComputed = (name: string, description: string): string => {
  return " -" + description.slice(name.length);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("header", { class: "text-center pt-4" }, [
      _createElementVNode("h1", { class: "text-4xl font-bold" }, [
        _createTextVNode(" About "),
        _createElementVNode("span", { class: "text-green-600" }, " Abdurrakhman ")
      ])
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<section class=\"row align-items-center justify-content-evenly mb-4\" data-v-9a7e5198><div class=\"col-12 col-md-4 text-center mb-4\" data-v-9a7e5198><img src=\"" + _imports_0 + "\" alt=\"a nice looking person looking towards you\" class=\"img-fluid rounded-circle shadow\" data-v-9a7e5198></div><div class=\"col-12 col-md-7 px-4 px-md-0\" data-v-9a7e5198><p class=\"fs-5\" data-v-9a7e5198> My name is Abdurrakhman. I am 21 years old. I am an inspiring individual with a wealth of knowledge and experience to share. Passionate about learning and innovation, I strive to make a positive impact in everything I do. I am learning Web development, Web design. </p><p class=\"fs-5 mt-4\" data-v-9a7e5198> I write codes on my computers. I use Visual Studio Code to write code effectively, it is essential program for creating any computer understanding language. </p></div></section><hr data-v-9a7e5198>", 2)),
      _createElementVNode("section", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-3xl max-w-md text-center mt-4 font-bold" }, [
          _createTextVNode(" Technologies I use/used-to to create "),
          _createElementVNode("span", { class: "text-green-600" }, " a Web page ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aboutViewStore).companiesInfo, (logo, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("a", {
                  href: logo.href,
                  target: _unref(globalStore).isMobile ? '_self' : '_blank',
                  title: `click to get info about ${logo.name}`
                }, [
                  (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: logo.src,
                    alt: logo.alt,
                    class: "w-100 rounded-4 link-img"
                  }, null, 8, _hoisted_8))
                ], 8, _hoisted_7)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-12 col-md-8", _unref(globalStore).theme])
          }, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aboutViewStore).companiesInfo, (logo, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "rounded shadow-sm mb-4"
                }, [
                  _createElementVNode("a", {
                    href: logo.href,
                    class: "h4 mb-2 text-green-600",
                    target: _unref(globalStore).isMobile ? '_self' : '_blank'
                  }, _toDisplayString(logo.name), 9, _hoisted_10),
                  _createVNode(ReadMoreText, {
                    text: removeNameFromDescriptionComputed(logo.name, logo.description)
                  }, null, 8, ["text"])
                ]))
              }), 128))
            ])
          ], 2)
        ])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})